import React, { useEffect } from "react";
import { ArrowBack } from "../components/CustomIcons";
import Navbar from "../components/Navbar";
import { Link, useParams } from "react-router-dom";
import Footer from "../components/Footer";
import { getLeagueBySlug } from "../components/leagueLocker/firestoreQuery";
import StyledLoadingSpinner from "../components/ui/StyledLoadingSpinner";
import AddEditChallenge from "../components/leagueLocker/AddEditChallenge";
import AddEditChallengeStakes from "../components/leagueLocker/AddEditChallengeStakes";
import LeagueAdditionalDetails from "../components/leagueLocker/leagueAdditionalDetails";

const ManageChallengePage: React.FC = () => {
  const { leagueUrl } = useParams();
  const [isLoading, setIsLoading] = React.useState(true);
  const [leagueData, setLeagueData] = React.useState<any>(null);
  const [errorText, setErrorText] = React.useState<string | null>(null);
  const [selectedTab, setSelectedTab] = React.useState(1);
  const [createdChallengeId, setCreatedChallengeId] = React.useState<
    string | null
  >(null);
  const steps = [1, 2, 3];

  useEffect(() => {
    const fetchLeagueDetails = async () => {
      if (leagueUrl) {
        try {
          const res = await getLeagueBySlug(leagueUrl);
          if (res) {
            setLeagueData(res);
          } else {
            setErrorText("No league found");
          }
        } catch (error) {
          setErrorText(error as string);
        }
      }
      setIsLoading(false);
    };
    fetchLeagueDetails();
  }, [leagueUrl, selectedTab]);

  if (isLoading) {
    return (
      <div className="pageOuterWrapper">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
            width: "100%",
          }}
        >
          <StyledLoadingSpinner />
        </div>
      </div>
    );
  }

  if (errorText) {
    return (
      <div className="pageOuterWrapper">
        <div>No League Found </div>
      </div>
    );
  }

  return (
    <div className="pageOuterWrapper">
      <Navbar />
      <div className="contentArea otherContentArea">
        <div className="wrapper">
          <ul className="stepWrap">
            {steps.map((step) => (
              <li
                key={step}
                className={selectedTab >= step ? "active" : ""}
              ></li>
            ))}
          </ul>
          <div className="backWrap">
            <Link to={`/${leagueUrl}`}>
              <ArrowBack /> Back
            </Link>
          </div>

          {selectedTab === 1 && (
            <AddEditChallenge
              leagueData={leagueData}
              setSelectedTab={setSelectedTab}
              setCreatedChallengeId={setCreatedChallengeId}
              createdChallengeId={createdChallengeId}
            />
          )}

          {selectedTab === 2 && (
            <AddEditChallengeStakes
              leagueData={leagueData}
              createdChallengeId={createdChallengeId}
              setSelectedTab={setSelectedTab}
            />
          )}
          {selectedTab === 3 && (
            <LeagueAdditionalDetails
              leagueData={leagueData}
              setSelectedTab={setSelectedTab}
              createdChallengeId={createdChallengeId}
            />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManageChallengePage;
